(function(){
  if(window.__apx)return;window.__apx=1;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    var els=[].slice.call(document.querySelectorAll('.apx-reveal'));
    if(!reduce&&'IntersectionObserver' in window&&!(window.Shopify&&Shopify.designMode)){
      document.documentElement.classList.add('apx-js');
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.05});
      els.forEach(function(el){io.observe(el)});
      setTimeout(function(){els.forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight)el.classList.add('is-in')})},60);
    }
    document.addEventListener('click',function(ev){
      var b=ev.target.closest('[data-apx-dir]');if(!b)return;
      var sl=document.getElementById(b.getAttribute('data-apx-target'));if(!sl)return;
      var c=sl.firstElementChild,w=c?c.getBoundingClientRect().width+16:300;
      sl.scrollBy({left:w*(b.getAttribute('data-apx-dir')==='next'?1:-1)*(innerWidth>900?2:1),behavior:reduce?'auto':'smooth'});
    });
    /* nav: menu drawer */
    var drawer=document.querySelector('[data-apx-drawer]'),lastFocus=null;
    function setDrawer(open){
      if(!drawer)return;
      drawer.classList.toggle('is-open',open);drawer.setAttribute('aria-hidden',open?'false':'true');
      document.body.classList.toggle('apx-lock',open);
      [].forEach.call(document.querySelectorAll('[data-apx-menu-open]'),function(b){b.setAttribute('aria-expanded',open?'true':'false')});
      if(open){lastFocus=document.activeElement;var f=drawer.querySelector('a,button');if(f)setTimeout(function(){f.focus()},90)}else if(lastFocus){lastFocus.focus();lastFocus=null}
    }
    document.addEventListener('click',function(ev){
      if(ev.target.closest('[data-apx-menu-open]')){ev.preventDefault();setDrawer(true);return}
      if(ev.target.closest('[data-apx-menu-close]')||ev.target===drawer){setDrawer(false);return}
      if(ev.target.closest('[data-apx-drawer] a'))setDrawer(false);
    });
    document.addEventListener('keydown',function(ev){
      if(!drawer||!drawer.classList.contains('is-open'))return;
      if(ev.key==='Escape'){setDrawer(false);return}
      if(ev.key==='Tab'){var f=drawer.querySelectorAll('a[href],button');if(!f.length)return;var first=f[0],last=f[f.length-1];
        if(ev.shiftKey&&document.activeElement===first){ev.preventDefault();last.focus()}else if(!ev.shiftKey&&document.activeElement===last){ev.preventDefault();first.focus()}}
    });
    /* nav: cart icon opens the theme's own cart drawer; badge mirrors the theme's cart bubble */
    var bubble=document.getElementById('cart-icon-bubble');
    document.addEventListener('click',function(ev){
      var c=ev.target.closest('[data-apx-cart]');if(!c)return;
      if(bubble&&document.querySelector('cart-drawer')){ev.preventDefault();setDrawer(false);bubble.click()}
    });
    function syncCount(){
      var badges=document.querySelectorAll('[data-apx-cart-count]');if(!badges.length||!bubble)return;
      var src=bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]')||bubble.querySelector('.cart-count-bubble span');
      var n=src?src.textContent.trim():'';
      [].forEach.call(badges,function(b){b.textContent=n;b.hidden=!n||n==='0'});
    }
    if(bubble&&'MutationObserver' in window){new MutationObserver(syncCount).observe(bubble,{childList:true,subtree:true,characterData:true})}
    /* nav: glass darkens once scrolled */
    var bar=document.querySelector('.apx-mmnav__bar');
    if(bar){var onS=function(){bar.classList.toggle('is-scrolled',window.scrollY>40)};onS();window.addEventListener('scroll',onS,{passive:true})}
    var sb=document.querySelector('[data-apx-stickybar]');
    if(sb){var after=parseInt(sb.getAttribute('data-apx-stickybar'),10)||900;var sf=function(){var show=window.scrollY>after&&(window.innerHeight+window.scrollY)<(document.documentElement.scrollHeight-500);sb.hidden=!show};sf();window.addEventListener('scroll',sf,{passive:true})}
    [].forEach.call(document.querySelectorAll('[data-apx-countdown]'),function(el){
      var mins=parseInt(el.getAttribute('data-apx-countdown'),10)||15,key='apx-cd',end;
      try{end=parseInt(sessionStorage.getItem(key),10)}catch(e){}
      if(!end||end<Date.now()){end=Date.now()+mins*60000;try{sessionStorage.setItem(key,end)}catch(e){}}
      function tick(){var t=Math.max(0,end-Date.now()),p=function(n){return(n<10?'0':'')+n};
        var h=Math.floor(t/3600000),m=Math.floor(t%3600000/60000),s=Math.floor(t%60000/1000);
        el.textContent=p(h)+' : '+p(m)+' : '+p(s)}
      tick();setInterval(tick,1000);
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
